import {
    apiRequest,
    organizationDetail
} from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", organizationDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository